import { useState, useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useGlobal } from '../../Core/GlobalState/Store';
import pattern from '../../pattern.svg';
import { useTranslation } from 'react-i18next';
import SettingsService from '../../Core/Services/SettingsService';

const PaymentStatus = () => {
  const { t } = useTranslation();

  const stripe = useStripe();
  const [message, setMessage] = useState();
  const [clientSecret, setClientSecret] = useState(null);
  const [showSuccess, setShowSuccess] = useState(true);
  const [showError, setShowError] = useState(false);
  const { pluginUrl, loading, setLoading } = useGlobal();

  useEffect(() => {
    if (!stripe) {
      return;
    }
    // Retrieve the "payment_intent_client_secret" query parameter appended to
    // your return_url by Stripe.js
    const secret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    );
    setClientSecret(secret);

    if (!secret) return;

    // Retrieve the PaymentIntent
    stripe.retrievePaymentIntent(secret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          setMessage('Success! Payment received.');
          setShowSuccess(true);
          break;
        case 'processing':
          setMessage(
            "Payment processing. We'll update you when payment is received."
          );
          setShowSuccess(false);
          break;
        case 'requires_payment_method':
          setMessage('Payment failed. Please try another payment method.');
          setShowSuccess(false);
          setShowError(true);
          break;
        default:
          setMessage('Something went wrong.');
          setShowSuccess(false);
          setShowError(true);
          break;
      }
    });
  }, [stripe]);

  return (
    <div
      className="w-full flex flex-col  !border-solid !border-l !border-r border-gray-300 "
      style={{
        backgroundImage: `url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }}
    >
      <div className="mb-2 h-[180px] md:h-[250px] text-center flex flex-col justify-center items-center">
        <div
          className="text-uppercase font-medium text-sm"
          style={{ color: '#BF4B30' }}
        >
          {t('receipt')}
        </div>
        <h1 className="text-2xl md:text-5xl font-bold">
          {' '}
          {t('booking_confirmation_title')}
        </h1>
      </div>
      <div className="!border !border-solid border-gray-400">
        <div className="p-6 md:p-14 flex flex-col gap-6">
          {showSuccess && (
            <>
              <div>
                <div className="font-bold text-3xl">
                  {t('booking_confirmation_message')}
                </div>
              </div>
              <div className="md:!border !border-solid border-gray-400 ">
                <div className="flex flex-col gap-4 md:flex-row p-2 md:p-10">
                  <div
                    style={{ backgroundColor: '#EBEFF8' }}
                    className="font-bold w-6 h-6 md:w-10 md:h-10 text-center"
                  >
                    1
                  </div>
                  <div>
                    <div className="font-bold">
                      {t('booking_confirmation_email')}
                    </div>
                    <div className="text-base">
                      {t('booking_confirmation_email_message')}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-4 md:flex-row p-2 md:p-10">
                  <div
                    style={{ backgroundColor: '#EBEFF8' }}
                    className="font-bold w-6 h-6 md:w-10 md:h-10 text-center"
                  >
                    2
                  </div>
                  <div>
                    <div className="font-bold">
                      {t('booking_confirmation_key_pickup')}
                    </div>
                    <div className="text-base">
                      {t('booking_confirmation_key_pickup_message')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-base">
                {t('booking_confirmation_support_message')}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentStatus;
